const signInCredentials = {
    Credentials: 'credentials',
};

export default signInCredentials;
